import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetClients } from "../../components/TimeTracker/TimeTrackerOverview/useTimeTracker";
import ReportServicesFilter from "../../components/Reporting/ReportingServices/ReportingServicesFilter";
import ReportServicesTotalHours from "../../components/Reporting/ReportingServices/ReportingServicesTotalHours";
import ReportServicesTotalCost from "../../components/Reporting/ReportingServices/ReportServicesTotalCost";
import ReportServicesTotalInvoiced from "../../components/Reporting/ReportingServices/ReportServicesTotalInvoiced";
import ReportServicesTotalRoi from "../../components/Reporting/ReportingServices/ReportServicesTotalRoi";
import ReportServicesHoursPerServiceFilter from "../../components/Reporting/ReportingServices/ReportPerServiceTotalHoursGraphFilter";
import ReportServicesHoursPerServiceGraph from "../../components/Reporting/ReportingServices/ReportPerServiceTotalHoursGraph";
import ReportCostInvoicedGraph from "../../components/Reporting/ReportingServices/ReportServiceCostGraph";
import ReportCostInvoicedGraphFilter from "../../components/Reporting/ReportingServices/ReportServiceCostGraphFilter";
import { useFetchTrackReportDetails, useFetchClientInvoices, useFetchExpenses, useFetchProjectCosts } from "../../features/reporting/reportingOverview/useReportingOverview";
import { setHeaderText } from "../../features/headerText/headerTextSlice";
import { useTagDetails } from "../../components/TimeTracker/Timer/tracker/TimerDataApi";
import TotalHoursPerServiceGraphFilter from "../../components/Reporting/ReportingServices/GraphFilters/ReportTotalHoursPerService/ReportTotalHoursPerServiceFilter";
import CostPerServiceGraphFilter from "../../components/Reporting/ReportingServices/GraphFilters/ReportCostPerService/ReportCostPerServiceFilter";
import { setAppLoading } from "../../features/appSettings/appSettingsSlice";

function ReportingServices() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [isGraphLoaded, setIsGraphLoaded] = useState(false);
    let token = null;
    if (user) {
        if (user && user.token) {
            token = user.token;
        }
    }

    const filteredCurrencies = useSelector((state) => state.reportingServices.servicesCurrency);

    const { data: tag = [], isLoading: tagLoading, isError: tagError } = useTagDetails(token);
    const { data: clients = [], isLoading: clientLoading, isError: clientError } = useGetClients(token);
    const { data: trackReport = [], isLoading: trackReportLoading, isError: trackReportError } = useFetchTrackReportDetails(token);
    const { data: projectCost = [], isLoading: projectCostLoading, isError: projectCostError } = useFetchProjectCosts(token);
    const { data: clientInvoices = [], isLoading: clientInvoicesLoading, isError: clientInvoicesError } = useFetchClientInvoices(token);
    const { data: expenses = [], isLoading: expensesLoading, isError: expensesError } = useFetchExpenses(token);

    useEffect(() => {
        dispatch(setAppLoading(tagLoading || clientLoading || trackReportLoading || projectCostLoading || clientInvoicesLoading || expensesLoading));
    }, [tagLoading, clientLoading, trackReportLoading, projectCostLoading, clientInvoicesLoading, expensesLoading, dispatch]);


    useEffect(() => {
        dispatch(setHeaderText("Services"));
        const timer = setTimeout(() => {
            setIsGraphLoaded(true);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);
    return (
        <div className="react-outer">
            <div className="invoice-outer-invoice invoice-outer-invoice-reprt">
                <ReportServicesFilter tag={tag} clients={clients} trackReport={trackReport} projectCost={projectCost} />
            </div>
            <div className="repot-tatal-box-sec">
                <ReportServicesTotalHours trackReport={trackReport} filteredCurrencies={filteredCurrencies} />
                <ReportServicesTotalCost trackReport={trackReport} projectCost={projectCost} filteredCurrencies={filteredCurrencies} />
                <ReportServicesTotalInvoiced clientInvoices={clientInvoices} filteredCurrencies={filteredCurrencies} />
                <ReportServicesTotalRoi trackReport={trackReport} projectCost={projectCost} clientInvoices={clientInvoices} expenses={expenses} filteredCurrencies={filteredCurrencies} />
            </div>
            <div className="outer-report-graph-piechart">
                <div className="graph-main-outer-time graph-main-outer-time-report">
                    <div className="top-graph">
                        <TotalHoursPerServiceGraphFilter
                            trackReport={trackReport}
                            trackReportLoading={trackReportLoading}
                            trackReportError={trackReportError}
                            filteredCurrencies={filteredCurrencies}
                        />
                    </div>
                    {isGraphLoaded ? (
                        <ReportServicesHoursPerServiceGraph
                            trackReport={trackReport}
                            trackReportLoading={trackReportLoading}
                            trackReportError={trackReportError}
                            filteredCurrencies={filteredCurrencies}
                        />
                    ) : (
                        (() => {
                            const skeletonRows = 8;
                            const rowHeight = 50;
                            const baseHeight = 100;
                            const skeletonHeight = skeletonRows * rowHeight + baseHeight;
                            
                            // Fixed widths for skeleton bars to avoid random values
                            const barWidths = [45, 60, 35, 55, 40, 50, 38, 48];
                            
                            return (
                                <div className='graph-project-per-hour' style={{ width: '100%', height: Math.max(542, skeletonHeight) }}>
                                    <div style={{ 
                                        width: '100%', 
                                        height: '100%', 
                                        padding: '20px 42px 5px 30px',
                                        position: 'relative'
                                    }}>
                                        {/* Y-axis skeleton labels */}
                                        <div style={{ 
                                            position: 'absolute', 
                                            left: '0', 
                                            top: '20px', 
                                            bottom: '5px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            paddingRight: '10px'
                                        }}>
                                            {Array.from({ length: skeletonRows }).map((_, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        width: '120px',
                                                        height: '13px',
                                                        backgroundColor: '#e5e7eb',
                                                        borderRadius: '4px',
                                                        animation: 'pulse 1.5s ease-in-out infinite',
                                                    }}
                                                />
                                            ))}
                                        </div>

                                        {/* Chart area with bars */}
                                        <div style={{ 
                                            marginLeft: '150px',
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            paddingTop: '10px',
                                            paddingBottom: '30px'
                                        }}>
                                            {Array.from({ length: skeletonRows }).map((_, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        height: '50px',
                                                        position: 'relative'
                                                    }}
                                                >
                                                    {/* Single bar skeleton */}
                                                    <div
                                                        style={{
                                                            width: `${barWidths[index] || 45}%`,
                                                            height: '13px',
                                                            backgroundColor: '#87ABE2',
                                                            opacity: 0.3,
                                                            borderRadius: '2px',
                                                            animation: 'pulse 1.5s ease-in-out infinite',
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>

                                        {/* X-axis skeleton ticks */}
                                        <div style={{ 
                                            position: 'absolute', 
                                            bottom: '5px', 
                                            left: '150px', 
                                            right: '42px',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-end'
                                        }}>
                                            {Array.from({ length: 6 }).map((_, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        width: '40px',
                                                        height: '12px',
                                                        backgroundColor: '#e5e7eb',
                                                        borderRadius: '4px',
                                                        animation: 'pulse 1.5s ease-in-out infinite',
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    <style>{`
                                        @keyframes pulse {
                                            0%, 100% {
                                                opacity: 1;
                                            }
                                            50% {
                                                opacity: 0.5;
                                            }
                                        }
                                    `}</style>
                                </div>
                            );
                        })()
                    )}
                </div>
                <div className="pie-chart-right-no"></div>
            </div>
            <div className="outer-report-graph-piechart">
                <div className="graph-main-outer-time graph-main-outer-time-report border-line-bottom">
                    <div className="top-graph">
                        <CostPerServiceGraphFilter
                            trackReport={trackReport}
                            trackReportLoading={trackReportLoading}
                            trackReportError={trackReportError}
                            projectCost={projectCost}
                            filteredCurrencies={filteredCurrencies}
                        />
                    </div>
                    <ReportCostInvoicedGraph
                        trackReport={trackReport}
                        trackReportLoading={trackReportLoading}
                        trackReportError={trackReportError}
                        projectCost={projectCost}
                        filteredCurrencies={filteredCurrencies}
                    />
                </div>
                <div className="pie-chart-right-no"></div>
            </div>
        </div>
    );
}
export default ReportingServices; 